import { EFeature } from 'app/types/rest/IUserMeta';
import { IApplicationState } from '../../../../../types/types';
import { isNewFeatureForUser } from '../isNewFeatureForUser';
import {
    COMMENT_ATTACHMENT_ADDED
} from '../../../../../view/react_components/base/components/Comments/helpers/setCommentAttachmentAddedSessionStorage';

export const getIsNewFeaturePasteCommentAttachment = (
    state: IApplicationState
): boolean => {
    const isNewFeature = isNewFeatureForUser(state, EFeature.PASTE_COMMENT_ATTACHMENT);
    if (
        !isNewFeature ||
        !sessionStorage.getItem(COMMENT_ATTACHMENT_ADDED)
    ) {
        return false;
    }

    return true;
};
